// Variant switching
// Variant switching
document.addEventListener('click', function (e) {
  const variantBtn = e.target.closest('.variant-btn');
  if (!variantBtn) return;

  e.preventDefault();
  e.stopPropagation();

  const wrapper = variantBtn.closest('.product-card-variants');
  if (!wrapper) return;

  const hiddenInput = wrapper.querySelector('.selected-variant-id');

  // Remove active state from all variant buttons
  wrapper.querySelectorAll('.variant-btn').forEach(btn =>
    btn.classList.remove('is-active')
  );

  // Activate clicked variant
  variantBtn.classList.add('is-active');

  // Update selected variant ID
  if (hiddenInput) {
    hiddenInput.value = variantBtn.dataset.variantId;
  }

  // Update price
  const priceEl = wrapper
    .closest('.card__content')
    .querySelector('.price-item--regular, .price-item--sale');

  if (priceEl) {
    priceEl.textContent = variantBtn.dataset.variantPrice;
  }
});


// Add to cart
document.addEventListener('click', async function (e) {
  const addBtn = e.target.closest('.product-card-add');
  if (!addBtn) return;

  e.preventDefault();
  e.stopPropagation();

  const wrapper = addBtn.closest('.product-card-variants');
  const variantId = wrapper.querySelector('.selected-variant-id').value;

  try {

    const card = addBtn.closest('.card');
const productTitle =
  card.querySelector('.card__heading a')?.textContent.trim();

const productImage =
  card.querySelector('.card__media img')?.src;

const variantTitle =
  wrapper.querySelector('.variant-btn.is-active')?.textContent.trim();


    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json',
                  'Accept': 'application/json'},
      body: JSON.stringify({
        id: variantId,
        quantity: 1,
        sections: ['cart-icon-bubble'],
        sections_url: window.location.pathname
      })
    });

    const data = await res.json();

const bubbleContainer = document.querySelector('#cart-icon-bubble');

    if (!res.ok) {
    console.error('Shopify error:', data);
    throw new Error('Add to cart failed');
  }

    if (data.sections?.['cart-icon-bubble'] && bubbleContainer) {
  const bubble = document.querySelector('#cart-icon-bubble');
    if (bubble) {
      bubble.innerHTML = data.sections['cart-icon-bubble'];
    }
  
}

    const video = addBtn.querySelector('.bag-animate');

addBtn.classList.add('is-animating');

// restart GIF reliably
const gif = addBtn.querySelector('.bag-animate');
if (gif) {
  gif.src = gif.src;
}

setTimeout(() => {
  addBtn.classList.remove('is-animating');
}, 900); // match GIF duration

    if (!res.ok) throw new Error('Add to cart failed');
    document.dispatchEvent(new CustomEvent('cart:refresh'));

  } catch (err) {
    console.error(err);
  }
});
